import { ChakraFlex as Flex, ChakraBox as Box } from "@airhelp/react-ui-components";
import type { SbEditableComponentProps } from "types/storyblok";
import { CardMobile } from "../Card";
import type { CardsProps } from "./Cards.d";

const CardsMobile = ({ cards, sbEditable }: SbEditableComponentProps<CardsProps>) => (
  <Box
    gridColumn="span 12"
    overflowX="scroll"
    overflowY="hidden"
    mx={-4}
    sx={{
      msOverflowStyle: "none",
      "&::-webkit-scrollbar": {
        display: "none",
      },
    }}
  >
    <Flex px={4} py={1} {...sbEditable}>
      {cards.map(({ _uid, icon, heading, text, subHeading }) => (
        <CardMobile key={_uid} icon={icon} heading={heading} text={text} subHeading={subHeading} />
      ))}
    </Flex>
  </Box>
);

export default CardsMobile;
